import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  chatThreads: [],
  currentThreadId: null,
}

const chatThreadsSlice = createSlice({
  name: 'chatThreads',
  initialState,
  reducers: {
    addThreadId: (state, action) => {
      const threadId = action.payload
      if (!state.chatThreads.includes(threadId)) {
        state.chatThreads.push(threadId)
      }
    },
    setCurrentThreadId: (state, action) => {
      const threadId = action.payload
      state.currentThreadId = threadId
      if (!state.chatThreads.includes(threadId)) {
        state.chatThreads.push(threadId)
      }
    },
    resetThreads: () => initialState,
  },
})

export const { addThreadId, setCurrentThreadId, resetThreads, loadStateFromStorage } =
  chatThreadsSlice.actions

export default chatThreadsSlice.reducer
